import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { ConfirmDialogHost } from './components/ui';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import InvoicePage from './pages/InvoicePage';
import InquiryPage from './pages/InquiryPage';
import ChangeContactPage from './pages/ChangeContactPage';

/**
 * 案2-d Step 3 (Task A): bundle分離（案Z）— 取引先入口側 App。
 *
 * このバージョンは SWA `invoice.soumubucho.com`（取引先入口）配信用。
 * 管理画面（/console/*）の import は一切含まない → bundle に管理画面コードが混入しない。
 *
 * - `/login` `/register` `/invoice` `/inquiry` `/change-contact` のみ
 * - `/console/*` はこの bundle に来ない想定（SWA staticwebapp.config.json で上流が分岐）
 *   万一来た場合は `/login` にフォールバック（既存挙動踏襲）
 */

const queryClient = new QueryClient();

function RegisterComplete() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f4f8' }}>
      <div style={{ background: '#fff', borderRadius: 12, padding: 40, maxWidth: 400, textAlign: 'center', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
        <h2 style={{ color: '#276749' }}>登録が完了しました</h2>
        <p style={{ color: '#718096', lineHeight: 1.7 }}>
          ご登録ありがとうございます。<br />
          月末に請求書提出のご案内メールをお送りします。
        </p>
      </div>
    </div>
  );
}

export default function AppPublic() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          {/* 取引先向け */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/register/complete" element={<RegisterComplete />} />
          <Route path="/invoice" element={<InvoicePage />} />
          <Route path="/inquiry" element={<InquiryPage />} />
          <Route path="/change-contact" element={<ChangeContactPage />} />

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
      <ConfirmDialogHost />
    </QueryClientProvider>
  );
}
